import { auth, database, getDBServerValue } from '@/plugins/firebase';
import { signInAnonymously } from 'firebase/auth';
import { goOnline, goOffline } from 'firebase/database';

let isInitialized = false;

export default () => {
  const signInAnon = async () => {
    try {
      const userCredential = await signInAnonymously(auth);
      return userCredential;
    } catch (err) {
      console.error('Anonymous sign-in failed', err);
      throw err;
    }
  };

  const initDB = () => {
    goOnline(database);
    return database;
  };

  const resetDB = () => {
    goOffline(database);
    isInitialized = false;
  };

  const getUid = () => {
    const currentUser = auth.currentUser;
    return currentUser?.uid || null;
  };

  const initFirebase = async (signIn = true) => {
    if (isInitialized) return;
    if (signIn) {
      await signInAnon();
    }
    initDB();
    isInitialized = true;
  };

  const getTimestampKey = () => {
    return getDBServerValue();
  };

  return {
    initFirebase,
    initDB,
    resetDB,
    signInAnonymously: signInAnon,
    getTimestampKey,
    getUid,
  };
};
